import React from 'react';
import { Box, Typography } from '@mui/material';
import { StatusChip } from '../../../../components/ui';
import { brandHome } from '../../brandHomeTokens';
import type { StoreSetupStep } from '../../storeViewModel';

interface StoreSetupPanelProps {
  steps: StoreSetupStep[];
}

/**
 * A store that listed the brand and has not connected a platform or chosen
 * products. This is unfinished setup, so it stays out of the issue tones.
 */
export const StoreSetupPanel: React.FC<StoreSetupPanelProps> = ({ steps }) => (
  <Box
    sx={{
      border: `1px solid ${brandHome.color.infoBorder}`,
      bgcolor: brandHome.color.infoTint,
      borderRadius: `${brandHome.radius.inset}px`,
      p: '10px 12px',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    }}
  >
    <Box>
      <Typography variant="overline" sx={{ color: brandHome.color.infoInk }}>
        Setup in progress
      </Typography>
      <Typography sx={{ fontSize: '12.5px', color: brandHome.color.bodyAlt }}>
        This store has not finished setup.
      </Typography>
    </Box>
    {steps.map((step) => (
      <Box key={step.id} sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1px', minWidth: 0, flex: '1 1 auto' }}>
          <Typography sx={{ fontSize: '13px', fontWeight: 600 }}>{step.label}</Typography>
          <Typography sx={{ fontSize: '11.5px', color: brandHome.color.muted }}>{step.detail}</Typography>
        </Box>
        <StatusChip label={step.stateLabel} tone={step.done ? 'positive' : 'neutral'} />
      </Box>
    ))}
  </Box>
);
